const configType: ConfigType = {
  baseUrl: 'https://product.wika.cn:8082/',
  clientType: 2,
}

export default configType
